/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { CustomerSubscriptionData_CustomerFragmentDoc } from '../../../../../../components/customers/__generated__/CustomersGridItem.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type EditCustomerNewMutationVariables = Types.Exact<{
  input: Types.CustomerUpdateInputNew;
}>;


export type EditCustomerNewMutation = { __typename: 'Mutation', customerUpdateNew: { __typename: 'Customer', id: string, handle: string, name: string, avatarUrl?: string | null, displayCount: number, waveSubscriptionUsage?: number | null, waveSubscription?: { __typename: 'WaveSubscription', id: string, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, validUntil: any, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> | null } };


export const EditCustomerNewDocument = gql`
    mutation EditCustomerNew($input: CustomerUpdateInputNew!) {
  customerUpdateNew(input: $input) {
    id
    handle
    name
    avatarUrl
    ...CustomerSubscriptionData_customer
  }
}
    ${CustomerSubscriptionData_CustomerFragmentDoc}`;
export type EditCustomerNewMutationFn = ApolloReactCommon.MutationFunction<EditCustomerNewMutation, EditCustomerNewMutationVariables>;

/**
 * __useEditCustomerNewMutation__
 *
 * To run a mutation, you first call `useEditCustomerNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCustomerNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCustomerNewMutation, { data, loading, error }] = useEditCustomerNewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCustomerNewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditCustomerNewMutation, EditCustomerNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditCustomerNewMutation, EditCustomerNewMutationVariables>(EditCustomerNewDocument, options);
      }
export type EditCustomerNewMutationHookResult = ReturnType<typeof useEditCustomerNewMutation>;
export type EditCustomerNewMutationResult = ApolloReactCommon.MutationResult<EditCustomerNewMutation>;
export type EditCustomerNewMutationOptions = ApolloReactCommon.BaseMutationOptions<EditCustomerNewMutation, EditCustomerNewMutationVariables>;